import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props } from './componentEl-33ff2aeb.js';

function Button(_ref) {
  let {
    active,
    componentEl: Component,
    children,
    className,
    color,
    disabled,
    fullWidth,
    icon,
    iconPosition,
    margin,
    primary,
    secondary,
    tertiary,
    justified,
    size
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["active", "componentEl", "children", "className", "color", "disabled", "fullWidth", "icon", "iconPosition", "margin", "primary", "secondary", "tertiary", "justified", "size"]);

  let cssClasses = ['st_btn'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (primary || secondary) cssClasses.push("st_btn--size-" + size);

  if (primary) {
    cssClasses.push('st_btn--primary');
  } else if (secondary) {
    cssClasses.push('st_btn--secondary');
  } else if (tertiary) {
    cssClasses.push('st_btn--tertiary');
  }

  if (active) cssClasses.push('st_btn--active');
  if (fullWidth) cssClasses.push('st_btn--full-width');
  if (disabled) cssClasses.push('st_btn--disabled');
  if (color && tertiary) cssClasses.push("st_btn--tertiary--" + color);

  const componentProps = _extends({}, otherProps); // add back disabled attribute only for button


  if (Component === 'button') {
    componentProps.disabled = disabled;
  } // don't add margin to button if there's no other content


  let buttonMargin = size === 'sm' ? 'xs' : 'sm';

  if (icon && !children) {
    buttonMargin = 'none';
  } // overwrite justify-content if justification included


  if (justified) {
    if (fullWidth) cssClasses.push("st_btn--justified-" + justified);
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, componentProps), icon && iconPosition === 'left' && /*#__PURE__*/React.createElement(Icon, {
    type: icon,
    size: "md",
    margin: {
      right: buttonMargin
    },
    className: "btn__icon"
  }), children, icon && iconPosition === 'right' && /*#__PURE__*/React.createElement(Icon, {
    type: icon,
    size: "md",
    margin: {
      left: buttonMargin
    },
    className: "btn__icon"
  }));
}

Button.propTypes = {
  /** whether button should show as active */
  active: PropTypes.bool,

  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** color, but applied only for tertiary */
  color: PropTypes.oneOf(['asphalt', 'blurple', 'emerald', 'gray', 'lava', 'white']),

  /** whether link/button is disabled */
  disabled: PropTypes.bool,

  /** whether button takes up all available horizontal space */
  fullWidth: PropTypes.bool,

  /** name of icon, if any */
  icon: PropTypes.string,

  /** position of icon relative to text */
  iconPosition: PropTypes.oneOf(['left', 'right']),

  /** left/top/right/bottom, and also size */
  margin: marginProps,

  /** whether button is Primary */
  primary: PropTypes.bool,

  /** whether buttonis Secondary */
  secondary: PropTypes.bool,

  /** whether button is tertiary */
  tertiary: PropTypes.bool,

  /** justification of button */
  justified: PropTypes.oneOf(['left', 'right', 'center']),

  /** size of button. Valid for primary and secondary only  */
  size: PropTypes.oneOf(['sm', 'md'])
};
Button.defaultProps = {
  active: false,
  componentEl: 'button',
  className: null,
  color: 'blurple',
  disabled: false,
  fullWidth: false,
  icon: null,
  iconPosition: 'left',
  margin: null,
  primary: false,
  secondary: false,
  tertiary: false,
  justified: null,
  size: 'md'
};

export default Button;
